import { Search } from "lucide-react";
import Button from "../../../_components/ui/Button";
import { useCommandCenter } from "../../../_context/CommandCenterContext/CommandCenterProvider";
import { isMacPlatform } from "../../../_utils/platform";
import "./NavSearchTrigger.scss";

const shortcutLabel = isMacPlatform() ? "⌘K" : "Ctrl K";

/**
 * Opens the real command center (src/_components/commandCenter) - was a
 * disabled visual-only placeholder. See docs/sidenav-design-parity-tasks.md
 * TICKET 3, now closed by this.
 */
export const NavSearchTrigger = ({ mini }) => {
  const { open } = useCommandCenter();

  if (mini) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      className="nav-search-trigger"
      onClick={open}
      icon={
        <Search
          className="nav-search-trigger__glyph"
          size={10}
          strokeWidth={2}
        />
      }
    >
      <span className="nav-search-trigger__label">Search…</span>
      <span className="nav-search-trigger__shortcut">{shortcutLabel}</span>
    </Button>
  );
};
